<script lang="ts">
    import type {CalendarDate, CalendarView} from 'shared/components/kp-calendar/types';
    import {createEventDispatcher, onDestroy} from 'svelte';
    import {areCalendarDatesEqual} from 'shared/components/kp-calendar/utils';
    import {KpCalendarManager} from 'shared/components/kp-calendar/kp-calendar-manager';
    import {exists} from 'shared/utils/custom-utils';
    import {fly} from 'svelte/transition';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpFlexRow from 'shared/layouts/flex/KpFlexRow.svelte';
    import KpFlexFullWidthSpacer from 'shared/layouts/flex/KpFlexFullWidthSpacer.svelte';

    export let startDate: CalendarDate;
    export let selectedDate: CalendarDate | null;

    const dispatch = createEventDispatcher<{'date-selected': CalendarDate}>();
    const calendarManager = KpCalendarManager.createNavigableCalendar({
        type: 'weekView',
        startDate
    });

    let calendarView: CalendarView;
    const calendarViewSubscription = calendarManager.getView$().subscribe((view) => calendarView = view);

    onDestroy(() => {
        calendarViewSubscription.unsubscribe();
    });
</script>

<KpFlexRow alignItems="center" gap="m">
    <KpIconButton icon="arrow-small-left" on:click={() => calendarManager.navigate(-1)}/>

    {#key calendarView}
        <div class="row-calendar" in:fly={{duration: 250, x: 10 * calendarView.navigateDirection}}>
            {#each calendarView.days as day(day)}
                <button class="row-calendar-day"
                        type="button"
                        class:day-selected={exists(selectedDate) ? areCalendarDatesEqual(selectedDate, day) : false}
                        on:click={() => dispatch('date-selected', day)}>

                    <span class="day-name">{day.day}.{day.month}.</span>
                </button>
            {/each}
        </div>
    {/key}

    <KpIconButton icon="arrow-small-right" on:click={() => calendarManager.navigate(1)}/>

    <KpFlexFullWidthSpacer/>

    <KpButton>
        <IconedContent icon="calendar">
            Podrobnější kalendář
        </IconedContent>
    </KpButton>
</KpFlexRow>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    @calendar-day-width: 64px;
    @calendar-day-height: 48px;

    .row-calendar {
        display: flex;
        overflow: hidden;
        border-radius: @border-radius-large;
        border: 1px solid @themed-border-default;

        .row-calendar-day {
            width: @calendar-day-width;
            height: @calendar-day-height;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: none;
            cursor: pointer;
            border-right: 1px solid @themed-border-default;
            background-color: @themed-body-bg;
            transition: background-color 0.3s ease-in-out;

            &:hover {
                background-color: @themed-panel-bg;
            }

            &:last-child {
                border-right: none;
            }

            &.day-selected {
                background-color: var(--brand-orange-new);
                color: white;

                .day-name {
                    font-weight: 500;
                }
            }
        }
    }
</style>